export default __webpack_public_path__ + "static/media/talksCardBackAlt.018d8722.svg";